// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThVVy9N7yeUvKJoJi2Gk {
  position: relative;
  z-index: 301;
  overflow-x: hidden;
}

.uFYPc8p4NctO3oE01U_h {
  height: 95%;
  overflow-y: hidden;
  background: rgb(var(--primary-bg));
  z-index: 301;
  overflow-x: hidden;
}

.U2pVCtdsdw3NRSpRQVRJ {
  display: flex;
  flex-direction: column;
  height: calc(100% - 37px);
}

.ZToztdpmOFTBwcVec6Xg {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
  z-index: 305;
}

.y2dDf5z9Dn8msjUBU00e {
  width: 100%;
}

.dLhxMFBcRGM5yVlp3OhD {
  color: rgb(var(--accent-brand));
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  padding: 0;
  background: transparent;
  cursor: pointer;
  border: none;
  transition: color 0.3s ease 0s;
  justify-content: flex-end;

  z-index: 305;
}

.dLhxMFBcRGM5yVlp3OhD > svg {
  > path {
    stroke: rgb(var(--accent-brand));
  }
}

.dLhxMFBcRGM5yVlp3OhD:first-child {
  justify-content: flex-start;
}

.dLhxMFBcRGM5yVlp3OhD:hover {
  color: #055ada;
  background: transparent;
}

.T6LgiHGSsHOS_DNbmb2e {
  font-size: 17px;
  font-weight: 760;
  letter-spacing: 0.43px;
  line-height: 129.41%;
  text-align: center;
  margin: 0 auto;
}

.zgELbp5n00PqQ0cs4GCd {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 40%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(0, 122, 255, 0.25);
  filter: blur(110px);
  -webkit-backdrop-filter: blur(110px); 
}`, "",{"version":3,"sources":["webpack://./src/pages/nft-detail/send-nft/send-nft.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;;EAEzB,YAAY;AACd;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;EACnB,oCAAoC;AACtC","sourcesContent":[".wrapper {\n  position: relative;\n  z-index: 301;\n  overflow-x: hidden;\n}\n\n.modal {\n  height: 95%;\n  overflow-y: hidden;\n  background: rgb(var(--primary-bg));\n  z-index: 301;\n  overflow-x: hidden;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 37px);\n}\n\n.modalTop {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 15px;\n  z-index: 305;\n}\n\n.empty {\n  width: 100%;\n}\n\n.modalTopButton {\n  color: rgb(var(--accent-brand));\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  transition: color 0.3s ease 0s;\n  justify-content: flex-end;\n\n  z-index: 305;\n}\n\n.modalTopButton > svg {\n  > path {\n    stroke: rgb(var(--accent-brand));\n  }\n}\n\n.modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n  color: #055ada;\n  background: transparent;\n}\n\n.modalTitle {\n  font-size: 17px;\n  font-weight: 760;\n  letter-spacing: 0.43px;\n  line-height: 129.41%;\n  text-align: center;\n  margin: 0 auto;\n}\n\n.background {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 40%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(0, 122, 255, 0.25);\n  filter: blur(110px);\n  -webkit-backdrop-filter: blur(110px); \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ThVVy9N7yeUvKJoJi2Gk`,
	"modal": `uFYPc8p4NctO3oE01U_h`,
	"content": `U2pVCtdsdw3NRSpRQVRJ`,
	"modalTop": `ZToztdpmOFTBwcVec6Xg`,
	"empty": `y2dDf5z9Dn8msjUBU00e`,
	"modalTopButton": `dLhxMFBcRGM5yVlp3OhD`,
	"modalTitle": `T6LgiHGSsHOS_DNbmb2e`,
	"background": `zgELbp5n00PqQ0cs4GCd`
};
export default ___CSS_LOADER_EXPORT___;
